import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import Typography from "components/common/Typography";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { getUIFormatDate } from "utils/DateHelper";

const PlanItem = (props: any) => {
  const { data } = props;
  const navigate = useNavigate();
  const { isMobileScreen } = useContext(ThemeContext);
  const { list } = useAppSelector((state) => state.functionalAreas);
  // @ts-ignore
  const fnArea = list.filter((l: any) => data?.functionalAreaIds?.some((f: any) => l.id === f));

  const handleNavigateToPlanDetails = () => {
    navigate(`/myplandetails/${data?.id}`);
  };

  return (
    <Stack
      direction={isMobileScreen ? "column" : "row"}
      spacing={2}
      alignItems={isMobileScreen ? "flex-start" : "center"}
      sx={{
        backgroundColor: tokens.Background.General.Primary,
        padding: isMobileScreen ? "16px" : "24px",
        borderRadius: "8px",
        marginBottom: "16px"
      }}
    >
      <Typography
        variant="h5"
        showBold
        color={tokens.Text.General.PrimaryHeadline}
        sx={{ flex: 1, marginBottom: isMobileScreen ? "8px" : 0 }}
      >
        {data.title}
      </Typography>
      <Stack
        flex="1"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: isMobileScreen ? "100%" : "auto" }}
      >
        <Stack spacing={2} direction="row" alignItems="center" sx={{ flex: 1, maxWidth: "320px", flexWrap: "wrap" }}>
          {fnArea.map((fn: any) => (
            <Typography
              key={fn.id}
              variant="label"
              showBold
              color={tokens.Text.General.Secondary}
              sx={{
                textTransform: "capitalize",
                padding: "4px 16px",
                border: `1px solid ${tokens.Border.General.Secondary}`,
                borderRadius: "100px",
                fontSize: "12px",
                marginBottom: "4px !important",
                marginLeft: "4px !important"
              }}
            >
              {fn.abbrv}
            </Typography>
          ))}
        </Stack>
        {!isMobileScreen && (
          <Typography variant="body2" color={tokens.Text.General.PrimaryBody} sx={{ flex: 1 }}>
            {getUIFormatDate(data?.dueDate)}
          </Typography>
        )}
        {!isMobileScreen && (
          <Stack sx={{ flex: 1 }}>
            <Typography variant="body2" showBold color={tokens.Text.General.PrimaryBody}>
              {data?.status}
            </Typography>
            <Box
              sx={{
                width: "80px",
                backgroundColor: tokens.Background.General.Tertiary,
                height: "2px",
                borderRadius: "100px",
                marginY: "8px",
                position: "relative",

                "&::after": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: `${Math.ceil(data?.totalCards > 0 ? (data?.cardsCompleted / data?.totalCards) * 100 : 0)}%`,
                  backgroundColor: colors.Cyan.Cyan400,
                  borderRadius: "100px"
                }
              }}
            />
            <Typography variant="label" color={tokens.Text.General.Tertiary}>
              {`${data?.cardsCompleted}/${data?.totalCards} done`}
            </Typography>
          </Stack>
        )}
        <Box sx={{ flex: 1, textAlign: "right" }}>
          <Button variant="outlined" label="View Details" onClick={handleNavigateToPlanDetails} />
        </Box>
      </Stack>
    </Stack>
  );
};

export default PlanItem;
